import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { api, ApiClientError } from '../lib/api';

interface Props {
  children: ReactNode;
}

type AuthState = 'loading' | 'authenticated' | 'unauthenticated';

export function RequireAuth({ children }: Props) {
  const [state, setState] = useState<AuthState>('loading');

  useEffect(() => {
    api
      .me()
      .then(() => setState('authenticated'))
      .catch((err: unknown) => {
        if (err instanceof ApiClientError) {
          setState('unauthenticated');
        } else {
          setState('unauthenticated');
        }
      });
  }, []);

  if (state === 'loading') {
    return (
      <div className="flex flex-1 items-center justify-center">
        <p className="text-neutral-500">Verifica sessione…</p>
      </div>
    );
  }
  if (state === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
